"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CheckmarkIcon = function CheckmarkIcon(_ref) {
  var fillColor = _ref.fillColor,
      size = _ref.size;

  if (size === _constants.Sizes.Small) {
    return /*#__PURE__*/_react["default"].createElement("svg", {
      viewBox: "0 0 8 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.20713 2.20711C7.59765 1.81658 7.59765 1.18342 7.20713 0.792893C6.81661 0.402369 6.18344 0.402369 5.79292 0.792893L3.00002 3.58579L2.20713 2.79289C1.81661 2.40237 1.18344 2.40237 0.792916 2.79289C0.402392 3.18342 0.402392 3.81658 0.792916 4.20711L2.29292 5.70711C2.68344 6.09763 3.31661 6.09763 3.70713 5.70711L7.20713 2.20711Z",
      fill: fillColor
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.50001 2.4142C9.89054 2.02367 9.89053 1.39051 9.50001 0.999985C9.10949 0.609461 8.47632 0.609461 8.0858 0.999985L3.50001 5.58577L1.91422 3.99999C1.5237 3.60946 0.890535 3.60946 0.50001 3.99999C0.109486 4.39051 0.109486 5.02367 0.50001 5.4142L2.7929 7.70709C3.18343 8.09762 3.81659 8.09762 4.20712 7.70709L9.50001 2.4142Z",
    fill: fillColor
  }));
};

CheckmarkIcon.propTypes = {
  fillColor: _propTypes["default"].string,
  kind: _propTypes["default"].string,
  size: _propTypes["default"].number
};
var _default = CheckmarkIcon;
exports["default"] = _default;